module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid pt-4"
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-wrap"
  }, [_vm._l((_vm.products), function(product) {
    return (_vm.products.length > 0) ? _c('div', {
      staticClass: "col-md-3 pointer mb-3"
    }, [_c('div', {
      staticClass: "productImageArea text-center lightest pt-3",
      style: ({
        'background-image': 'url(' + product.imageLogo + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.checkAvailability(product)
        }
      }
    }, [_c('div', {
      staticClass: "fs-smaller"
    }, [_vm._v(_vm._s(_vm.productCategories(product)))]), _vm._v(" "), _c('div', {
      staticClass: "fs-largest mt-3 pt-4 px-3"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('div', {
      staticClass: "checkAvailability bg-color-6 py-2 radius-normal"
    }, [_vm._v("\n                    Check Availability\n                ")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.products.length == 0) ? _c('div', {
    staticClass: "col-sm-12 dark fs-large font-weight-600 text-center mt-4"
  }, [_vm._v("\n            No products found, you can create them "), _c('router-link', {
    staticClass: "darker",
    attrs: {
      "to": {
        name: 'pluralo.product.new'
      }
    }
  }, [_vm._v("here")]), _vm._v(".\n        ")], 1) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-643d62fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-643d62fa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Search/ProductList.vue
// module id = 1744
// module chunks = 0